export default __webpack_public_path__ + "static/media/clothes.0f3d0987.png";